import { ThreeTermsAssignmentCtrl } from './three-terms-assignment.controller';

export const ThreeTermsAssignment = {
  controller: ThreeTermsAssignmentCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./three-terms-assignment.html'),
};
